import * as React from 'react'

import classNames from 'classnames/bind'

import RadioInput from './RadioInput'
import styles from './index.module.css'

const cx = classNames.bind(styles)
interface Props {
  label: string
  subtitle?: string
  onClick: () => void
  selected: boolean
}

const SelectOption = (props: Props) => {
  const { selected } = props

  return (
    <div
      className={cx('selectOption', {
        selected,
      })}
      onClick={props.onClick}
    >
      <div className={styles.labelContainer}>
        <div className={styles.label}>{props.label}</div>
        {props.subtitle && <div className={styles.subtitle}>{props.subtitle}</div>}
      </div>
      <RadioInput selected={props.selected} />
    </div>
  )
}

export default SelectOption
